import React from 'react';

import {Group, Item} from '@pb/kit-component-group';
import {ToolItem, ToolsRibbon, ToolsRibbonGroup} from '@pb/kit-component-tools-ribbon';

import {DeselectAllView} from './views/deselect-all-view';
import {SelectAllView} from './views/select-all-view';
import {SelectPageView} from './views/select-page-view';

type Props = {
    totalCount: number,
    pageIds: Array<number | string>,
    selectedCount: number,
    pageSelectedCount: number,
    allSelected: boolean,
    onSelectAll: () => void,
    onSelectPage: () => void,
    onClear: () => void,
    children?: React.ReactNode,
};
export const ToolsRibbonComponent: React.FC<Props> = ({
    totalCount,
    pageIds,
    selectedCount,
    pageSelectedCount,
    allSelected,
    onSelectAll,
    onSelectPage,
    onClear,
    children,
}) => {
    return (
        <ToolsRibbon shadow={false} justify="space-between">
            <Item grow={1}>
                <Group>
                    <ToolsRibbonGroup>
                        <ToolItem>
                            <strong>Selected {selectedCount}</strong>
                        </ToolItem>
                    </ToolsRibbonGroup>
                    <ToolsRibbonGroup>
                        <SelectAllView
                            totalCount={totalCount}
                            selectedCount={selectedCount}
                            onSelectAll={onSelectAll}
                        />
                        <SelectPageView
                            pageIds={pageIds}
                            pageSelectedCount={pageSelectedCount}
                            allSelected={allSelected}
                            onSelectPage={onSelectPage}
                        />
                        <DeselectAllView
                            selectedCount={selectedCount}
                            onClear={onClear}
                        />
                    </ToolsRibbonGroup>
                </Group>
            </Item>
            {children}
        </ToolsRibbon>
    );
};
